import { DTYPES } from "./constants";

const SOURCE_ID = "enverus_leases";
const LAYER_ID = "enverus_leases";
const BORDER_HIGHLIGHT_LAYER_ID = "enverus_leases_highlight";
const FILTER_LAYER_IDS = [LAYER_ID];
const CLICKABLE_LAYERS = [LAYER_ID];
const UNIQUE_COLUMN = "id";

const MIN_ZOOM = 12;
const API_BASE_ENDPOINT = "enverus-leases";
const TILE_ENDPOINT = `${
  process.env.REACT_APP_SERVER_URL
}/api/${API_BASE_ENDPOINT}/tiles/{z}/{x}/{y}.pbf?access_token=${localStorage.getItem(
  "authToken"
)}`;

const INITIAL_FILTER_STATE = {
  state: {
    column: "state",
    label: "State",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  county: {
    column: "county",
    label: "County",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  grantee_name: {
    column: "grantee_name",
    label: "Grantee Name",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  grantor_name: {
    column: "grantor_name",
    label: "Grantor Name",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  lease_id: {
    column: "lease_id",
    label: "Lease ID",
    dtype: DTYPES.INTEGER,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  record_date: {
    column: "record_date",
    label: "Record Date",
    dtype: DTYPES.DATE,
    value: {},
    excludeSelected: false,
    excludeNullValues: false,
  },
};

const EXPORT_COLUMNS = [
  { key: "id", label: "ID" },
  { key: "lease_id", label: "Lease ID" },
  { key: "state", label: "State" },
  { key: "county", label: "County" },
  { key: "acres", label: "Acres" },
  { key: "grantee_name", label: "Grantee Name" },
  { key: "grantor_name", label: "Grantor Name" },
  { key: "grantor_address", label: "Grantor Address" },
  {
    key: "record_date",
    label: "Record Date",
    type: "date",
    format: "YYYY-MM-DD",
  },
  { key: "mapping_id", label: "Mapping ID" },
  { key: "owner_name_address_id", label: "Owner Name/Address ID" },
  { key: "owner_id", label: "Owner ID" },
];

const STYLES = {
  "circle-radius": 5,
  "circle-color": "#721ea9",
  "circle-stroke-color": "#000",
  "circle-stroke-width": 0.5,
  "circle-opacity": 0.75,
};

const BORDER_HIGHLIGHT_STYLES = {
  "circle-radius": 7,
  "circle-color": "#721ea9",
  "circle-stroke-color": "#000",
  "circle-stroke-width": 2,
  "circle-opacity": 1,
};

const ADD_AFTER = "Bottoms";

const getLayerAfter = (map, layerId) => {
  const layers = map.getStyle().layers;
  const idx = layers.findIndex((l) => l.id === layerId);
  if (idx !== -1 && idx + 1 < layers.length) {
    return layers[idx + 1].id;
  }
  return undefined;
};

const addSource = (mapRef) => {
  if (!mapRef.current.getSource(SOURCE_ID)) {
    mapRef.current.addSource(SOURCE_ID, {
      type: "vector",
      tiles: [TILE_ENDPOINT],
      minzoom: MIN_ZOOM,
      maxzoom: 14,
    });
  }
};

const addLayers = (mapRef) => {
  const map = mapRef.current;
  const addBefore = getLayerAfter(map, ADD_AFTER);

  if (!map.getLayer(LAYER_ID)) {
    map.addLayer(
      {
        id: LAYER_ID,
        type: "circle",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        minzoom: MIN_ZOOM,
        layout: {
          visibility: "none",
        },
        paint: STYLES,
      },
      addBefore
    );
  }

  if (!map.getLayer(BORDER_HIGHLIGHT_LAYER_ID)) {
    map.addLayer(
      {
        id: BORDER_HIGHLIGHT_LAYER_ID,
        type: "circle",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        minzoom: MIN_ZOOM,
        layout: {},
        paint: BORDER_HIGHLIGHT_STYLES,
        filter: ["in", UNIQUE_COLUMN, ""],
      },
      addBefore
    );
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

export {
  EXPORT_COLUMNS,
  SOURCE_ID,
  LAYER_ID,
  BORDER_HIGHLIGHT_LAYER_ID,
  FILTER_LAYER_IDS,
  CLICKABLE_LAYERS,
  UNIQUE_COLUMN,
  STYLES,
  BORDER_HIGHLIGHT_STYLES,
  API_BASE_ENDPOINT,
  TILE_ENDPOINT,
  INITIAL_FILTER_STATE,
  addAll,
};
